import { LDProvider } from 'launchdarkly-react-client-sdk';
import { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import buildLaunchDarklyConfig from './launchDarklyConfig';
import { selectIsAuthenticated, selectUserData } from '../redux/selectors';

export function LaunchDarklyProvider({ children }: PropsWithChildren<Record<string, unknown>>): JSX.Element {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const userData = useSelector(selectUserData);
  const clientSideID = process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_SIDE_ID;
  if (!isAuthenticated || !clientSideID || !userData) {
    return <>{children}</>;
  }
  const ldUser = { key: userData.id, custom: userData.launchDarklyPayload };
  const disabled = process.env.REACT_APP_LAUNCH_DARKLY_DISABLED === 'true';
  // We only want to use the LaunchDarkly SDK if we have a client side ID and the user is authenticated
  return (
    <LDProvider {...buildLaunchDarklyConfig({ clientSideID, disabled })} user={ldUser}>
      {children}
    </LDProvider>
  );
}
